module.exports = __webpack_public_path__ + "static/media/sideBarSlotsgames.d6cdb627.svg";